/**
 * Browser-side calls to this app's route handlers. The absolute URL is what jsdom's fetch needs;
 * a browser resolves it to the same place.
 */
export const apiFetch = (path: string, init: RequestInit = {}) =>
  fetch(new URL(path, location.href), { cache: 'no-store', ...init })

export const postJson = (path: string, body: string, headers: Record<string, string> = {}) =>
  apiFetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', ...headers }, body })
